<template>


  <el-button v-if="visible" :disabled="disabled" type="info" plain size="small" @click="requestWorkflowInfo"><i
          class="fa fa-retweet"></i> {{buttonText == null ? "重新审核" : buttonText }}
  </el-button>


</template>


<script>

  import WorkflowApi from '../../api/workflow/workflow'
  import {WorkflowApiNew} from '../../api/workflow/workflow'

  export default {

    name: 'workflowRequestBtn',

    props: {
      bussiness: {},
      bussinessId: {},
      bussinessInfo: {},
      disabled: {},
      visible: {},
      buttonText: {},
      errorMsg: {},
      useNewApi: {
          type: Boolean,
          default: false,
      }
    },

    data() {

      return {

        workflowRequestInfo: {
          wfToken: '',
          ownerId: '',
          nodeInfo: {},
        }

      }

    },
    computed: {
      api() {
        return this.useNewApi === true ? WorkflowApiNew : WorkflowApi;
      }
    },


    methods: {

      requestWorkflowInfo() {

        if (this.errorMsg) {
          this.$message.error(this.errorMsg);
          return;
        }

        let params = {
          bussiness: this.bussiness,
          bussinessId: this.bussinessId,
          reopen: true,
        };
        params.params = {...this.bussinessInfo}.params;
        this.api.request(params).then((responseBody) => {

          this.workflowRequestInfo.wfToken = responseBody.wfToken;
          this.workflowRequestInfo.ownerId = responseBody.ownerId;
          this.workflowRequestInfo.nodeInfo = responseBody.node_info;
          this.workflowRequestInfo.params = params.params;

          this.$emit('afterRequestWorkflowFunc', this.workflowRequestInfo);

        }).catch(error => {
          this.$message.error(error);
        });
      },


    },


  }
</script>